import apiClient from "./axios.config";

const doumentService = {
  submitDoumentForm(payload) {
    return apiClient.put("/vendors/profile/business-info", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default doumentService;
